import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LyRippleModule } from 'alyle-ui/ripple-minimal';
import { LyIconButton } from './icon-button';
var LyIconButtonModule = /** @class */ (function () {
    function LyIconButtonModule() {
    }
    LyIconButtonModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule, LyRippleModule],
                    exports: [LyIconButton],
                    declarations: [LyIconButton],
                },] },
    ];
    /** @nocollapse */
    LyIconButtonModule.ctorParameters = function () { return []; };
    return LyIconButtonModule;
}());
export { LyIconButtonModule };
//# sourceMappingURL=icon-button.module.js.map